import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import DifferentlySection from '../components/DifferentlySection';
import ServicesSection from '../components/ServicesSection';
import CalculatorsSection from '../components/CalculatorsSection';
import StatsSection from '../components/StatsSection';
import NRISection from '../components/NRISection';
import PartnersSection from '../components/PartnersSection';
import CTASection from '../components/CTASection';
import TestimonialsSection from '../components/TestimonialsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <main>
        <HeroSection />
        <TestimonialsSection />
        <StatsSection />
        <DifferentlySection />
        <ServicesSection />
        <CalculatorsSection />
        <NRISection />
        <PartnersSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
